export default __webpack_public_path__ + "static/media/n-back.d63f2de1.svg";